const Extendable = {
  // shopper#417 : find recurring extension for enrollment
  extension: (lineItemsExtension, enrollment) => {
    return enrollment && (lineItemsExtension || []).find((lineItemExtension) => lineItemExtension.enrollment_to_extend == enrollment.id)
  },
  hasActiveExtension: (lineItemsExtension, enrollment) => {
    const extension = Extendable.extension(lineItemsExtension, enrollment)
    return enrollment && extension && !extension.needsPayment
  },
  isPrevious: (lineItemsExtension, subscription) => {
    const hasActiveExtension = Extendable.hasActiveExtension(lineItemsExtension, subscription.enrollment)
    return (subscription.enrollment && subscription.enrollment.isPrevious || !subscription.isActive) && !hasActiveExtension
  },
  flags: (lineItemsExtension, subscription) => {
    const results = []
    if (subscription.isRecurring) {
      results.push('is_recurring')
    }
    if (Extendable.hasActiveExtension(lineItemsExtension, subscription.enrollment)) {
      results.push('has_active_extension')
    }
    if (!subscription.isEnrolled) {
      results.push('no_enrollment')
    }
    if (subscription.enrollment && !subscription.enrollment.extensible) {
      results.push('enrollment_not_extensible')
    }
    if (subscription.isInstructorCourse) {
      results.push('is_instructor_course')
    }
    return results
  }
}

export default Extendable
